import { render, staticRenderFns } from "./selected-data-dialog.vue?vue&type=template&id=223d68d7"
import script from "./selected-data-dialog.vue?vue&type=script&lang=js"
export * from "./selected-data-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports